module.exports = __webpack_public_path__ + "static/media/IMG_1322.f5d6cdc4.jpg";